import type { Campaign, Scene, WorkspaceState } from "../types";
import { isPlayableMapScene } from "./media-map";

export function remoteCampaignScene(state: WorkspaceState, campaign: Campaign): Scene | undefined {
  const live = state.scenes.find((scene) => scene.id === state.presentation.activeSceneId && scene.campaignId === campaign.id);
  return live ?? state.scenes.find((scene) => scene.id === campaign.activeSceneId && scene.campaignId === campaign.id) ?? state.scenes.find((scene) => scene.campaignId === campaign.id);
}

/** Moves only the token linked to the approved hero, in bounded grid units. */
export function moveRemoteHeroToken(state: WorkspaceState, campaign: Campaign, heroId: string, requestedDx: number, requestedDy: number): WorkspaceState {
  const scene = remoteCampaignScene(state, campaign); if (!isPlayableMapScene(scene) || !scene.geometry) return state;
  const dx = Number.isFinite(requestedDx) ? Math.max(-1, Math.min(1, requestedDx)) : 0; const dy = Number.isFinite(requestedDy) ? Math.max(-1, Math.min(1, requestedDy)) : 0;
  if (!dx && !dy) return state;
  let moved = false;
  const tokens = scene.tokens.map((token) => {
    if (token.heroId !== heroId) return token;
    moved = true;
    return { ...token, position: { x: Math.max(0, Math.min(scene.geometry!.width, token.position.x + dx)), y: Math.max(0, Math.min(scene.geometry!.height, token.position.y + dy)) } };
  });
  if (!moved) return state;
  return { ...state, scenes: state.scenes.map((candidate) => candidate.id === scene.id ? { ...scene, tokens, updatedAt: Date.now() } : candidate) };
}
